import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Button from '../Button';
import Image from '../Image';

const div = document.createElement('div');
div.setAttribute('id', 'tour');
document.body.appendChild(div);

/**
 * Il componente viene utilizzato per renderizzare una guida al software o a parte di esso.
 */
class Tour extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slide: props.slide,
    };
  }

  UNSAFE_componentWillReceiveProps({ slide }) {
    const { slide: slideS } = this.state;
    if (slide !== slideS) {
      this.setState({
        slide,
      });
    }
  }

  saveState = (slide) => {
    const { onChange } = this.props;
    if (typeof onChange === 'function') {
      onChange(slide);
    }
  };

  indietro = () => {
    const { slide } = this.state;
    const prev = slide - 1;
    this.saveState(prev);
    this.setState({ slide: prev });
  };

  avanti = () => {
    const { slide } = this.state;
    const next = slide + 1;
    this.saveState(next);
    this.setState({
      slide: next,
    });
  };

  chiudi = () => {
    const { onEnd } = this.props;
    if (typeof onEnd === 'function') {
      onEnd(false);
    }
  };

  render() {
    const {
      onEnd,
      slides,
      width,
    } = this.props;
    const {
      slide,
    } = this.state;

    return createPortal(
      <div className="tour">
        <div
          className="tour__overlay"
          onClick={this.chiudi}
          role="presentation"
        >
          <div
            className="tour__container"
            onClick={(e) => e.stopPropagation()}
            style={{ width: `${width}px` }}
            role="presentation"
          >
            <div className="tour__slideContainer">
              <ul className="tour__slideList">
                {slides.map((x, i) => {
                  const classes = cns('tour__slide', `tour__slide-${i + 1}`, { 'tour__slide--active': i === slide });
                  return (
                    <li
                      className={classes}
                      key={i} // eslint-disable-line react/no-array-index-key
                    >
                      <Image
                        alt={`Tour slide ${i + 1}`}
                        title={`Tour slide ${i + 1}`}
                        src={x}
                        style={{ width: `${width - 20}px` }}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="tour__containerControlli">
              {slide > 0 && (
                <Button
                  className="tour__prev_button"
                  flat
                  onClick={this.indietro}
                  style={{ marginRight: '10px' }}
                >
                  Indietro
                </Button>
              )}
              {slide < slides.length - 1 && (
                <Button
                  className="tour__next_button"
                  flat
                  onClick={this.avanti}
                  primary
                >
                  Avanti
                </Button>
              )}
              {slide === slides.length - 1 && (
                <Button
                  className="tour__close_button"
                  flat
                  onClick={() => onEnd && onEnd(true)}
                  primary
                >
                  Fine
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>,
      div,
    );
  }
}

Tour.propTypes = {
  /**
   * Callback invocata al cambio di slide:
   * ```
   *  onChange(slide)
   * ```
   * dove:
   * * *slide*: index della nuova slide
   */
  onChange: PropTypes.func,
  /**
   * Callback invocata alla fine del tour:
   * ```
   *  onEnd(origin)
   * ```
   * dove:
   * * *origin*: `true` se chiusura proveniente dalla pressione del tasto
   *      FINE; `false` se premuto un punto esterno al tour
   */
  onEnd: PropTypes.func,
  /** Indice della slide iniziale */
  slide: PropTypes.number,
  /** Lista delle slide */
  slides: PropTypes.arrayOf(PropTypes.string),
  /** Indica la larghezza del componente */
  width: PropTypes.number,
};

Tour.defaultProps = {
  onChange: null,
  onEnd: null,
  slide: 0,
  slides: [],
  width: 940,
};

export default Tour;
